export enum AudienceConstants {
  Attributes = 'Attributes',
  RFM = 'RFM',
}
